export const IDs = {
    fileInput: 'dialog-upload-input',
}
